/* src/app/forms/produtos/mercadolivre/meli-item/meli-product-relation/meli-product-relation.component.scss */
.meli-card {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  min-height: 230px;
  padding: 12px;
  background: var(--tem-surface, #fff);
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: var(--tem-radius, 8px);
  transition: box-shadow 0.3s;
}
.meli-card:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.4);
}
.selected {
  border: red solid;
}
.meli-card-title {
  max-height: 60px;
  font-weight: 600;
  font-size: var(--tem-fs-lg, 16px);
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.meli-card-divider {
  margin: 8px 0;
}
.content-data {
  max-height: 110px;
  min-height: 110px;
}
.dados {
  margin: 20px;
  flex-grow: 3;
}
.title {
  font-weight: 500;
  font-size: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.sumario {
  width: 100%;
}
.sumario .left {
  padding: 6px;
  float: left;
  width: 100%;
}
.action-button {
  display: flex;
  flex-flow: column;
}
.meli-card-actions {
  margin-top: auto;
  padding-top: 8px;
}
.meli-card-actions button {
  width: 100%;
}
.responsive {
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=meli-product-relation.component.css.map */
